import { memo } from 'react';

interface EmptyStateProps {
  /** Material Symbols icon name */
  icon: string;
  message: string;
  hint?: string;
}

/**
 * Empty-result placeholder for dashboard lists and tables — both the
 * desktop table area and the mobile card list render this when a page
 * has zero rows, so filtered-out results never look like a broken page.
 */
export const EmptyState = memo(function EmptyState({ icon, message, hint }: EmptyStateProps) {
  return (
    <div className="dash-empty-state" role="status">
      <span className="material-symbols-outlined" aria-hidden="true">{icon}</span>
      <p className="dash-empty-state-message">{message}</p>
      {hint && <p className="dash-empty-state-hint">{hint}</p>}
    </div>
  );
});

export default EmptyState;
